import React from 'react';

/**
 * The DECIDED log under the queue (E2 §1.4): title · outcome chip · "{who} ·
 * {when}", newest first. Outcomes starting with "Approved" are green, the
 * rest neutral. Wiki admins also get Revert on rows the server marks
 * `can_revert` (contract §4.1/§4.2; the prototype has no Revert — its "turn
 * off" lives in the tree — but the decided rows are the only place an approved
 * proposal is listed).
 */
export default function DecidedLog({ rows = [], canManage = false, busy = {}, onRevert }) {
    return (
        <section className="wk-brq-decided" aria-label="Decided">
            <span className="wk-t-label wk-brq-decided-label">Decided</span>
            <div className="wk-brq-log" data-testid="brain-decided-log">
                {rows.length === 0 && (
                    <div className="wk-brq-log-row wk-brq-log-row--empty">
                        <span className="wk-t-meta">Nothing decided yet.</span>
                    </div>
                )}
                {rows.map((row, index) => {
                    const id = row.proposal_id || `${row.title}-${index}`;
                    const approved = String(row.outcome || '').indexOf('Approved') === 0;
                    const rowBusy = busy[row.proposal_id] === 'revert';
                    return (
                        <div key={id} className="wk-brq-log-row" data-testid="brain-decided-row" data-status={row.status || ''}>
                            <span className="wk-t-row wk-brq-log-title">{row.title}</span>
                            <span className={`wk-pill ${approved ? 'wk-pill--green' : 'wk-bro-pill--neutral'}`} data-testid="brain-decided-outcome">
                                {row.outcome}
                            </span>
                            <span className="wk-t-meta wk-brq-log-meta">{row.who} · {row.when}</span>
                            {canManage && row.can_revert && row.proposal_id && (
                                <button
                                    type="button"
                                    className="wk-btn wk-btn--secondary wk-brq-revert"
                                    onClick={() => onRevert && onRevert(row)}
                                    disabled={rowBusy}
                                    aria-busy={rowBusy || undefined}
                                    data-testid="brain-decided-revert"
                                >
                                    Revert
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
